// extracted by mini-css-extract-plugin
export default {"tldBadge":"BundleProductDescription-tldBadge_HbZ5G"};